export class Event {
  date: string;
  name: string;
  location: string;
}
